.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.targetMaturitySelectContainer {
    display: flex;
}

.targetMaturitySelect {
    margin-left: auto;
    margin-top: 10px;
}
